import { canUseDOM } from '@/utils/dom-utils';
import { getQueryStrings } from '@/utils/uri-utils';

// Consent Mode 接管标签 gating，dataLayer push 本身不再检查同意状态：
// 同意前 push 的事件会进入 dataLayer，但 GTM 容器内带 consent 设置的标签
// 只会在 consent 状态为 granted 时触发。
export const gtmPush = (data) => {
  if (!canUseDOM()) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

export function gtag() {
  if (!canUseDOM()) return;
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export const gtmCheckout = (page, step, features, event, currency) => {
  const [filterId, transferCode] = getQueryStrings('filter_id', 'transfer_code');
  let language = page.itemLanguage;
  // let region = 'GB',
  //   language = 'en';
  // if (page.itemLanguage !== 'en') {
  //   [language, region] = page.itemLanguage.split('-');
  // }
  const options = [];
  for (let feature of features) {
    for (let info of feature.infos) {
      options.push({
        option_id: info.code,
        option_name: info.label,
        option_category: feature.type,
        option_price: info.price?.price,
      });
    }
  }
  gtmPush({
    event,
    checkout_step: step,
    filter_id: filterId,
    transfer_code: transferCode,
    options,
    // region,
    language,
    currency: currency,
  });
};
